export default __webpack_public_path__ + "locales/cs/Webhooks.json?hash=52876c91ef64b5b5e49a44b238eadb09";